import { Building2 } from "lucide-react";
import { DetailSummary } from "@/shared/components/ui/DetailSummary";
import { SectionCard } from "@/shared/components/ui/SectionCard";
import type { Business } from "../types/businessTypes";

export function BusinessDetails({ business }: { business: Business }) {
  return (
    <SectionCard title={business.name} icon={<Building2 />} description="Your Froppio business.">
      <DetailSummary items={[
        { label: "Industry", value: business.industry || "Not specified" },
        { label: "Timezone", value: business.timezone },
        { label: "Currency", value: business.currency },
      ]} />
    </SectionCard>
  );
}
